export default __webpack_public_path__ + "static/media/816-solar-pros-bg.6bccf7df.png";